export const loadQuizPage = () => import('../pages/QuizPage')
